import { Button } from '@design/components/button/Button';
import { Icon } from '@design/components/icon/Icon';
import { useSortable } from '@dnd-kit/react/sortable';
import clsx from 'clsx';

import styles from './WebsiteCard.module.scss';

interface WebsiteCardProps {
  id: string;
  index: number;
  title: string;
  url: string;
  favicon: string;
  handleRemove?: (id: string) => void;
}

export const WebsiteCard = ({
  id,
  index,
  title,
  url,
  favicon,
  handleRemove,
}: WebsiteCardProps) => {
  const sortable = useSortable({ id, index });

  return (
    <div
      className={clsx(styles.cardWrapper, {
        [styles.dragging]: sortable.isDragging,
      })}
      ref={sortable.ref}
    >
      <div className={styles.dragHandle} ref={sortable.handleRef}>
        <Icon iconName="GripDotsVertical" size={16} />
      </div>
      <div className={clsx(styles.content, { [styles.onlyUrl]: !title })}>
        <img className={styles.favicon} src={favicon} alt={title} />
        <div className={styles.infoWrapper}>
          <span className={styles.title}>{title}</span>
          <span className={styles.url}>{url}</span>
        </div>
      </div>
      <Button
        iconName="Close"
        size="xsmall"
        variant="empty"
        onClick={() => {
          handleRemove?.(id);
        }}
      />
    </div>
  );
};
